/*!
Mailchimp Ajax Submit
jQuery Plugin
Author: Siddharth Doshi

Use:
===
$('#form_id').ajaxchimp(options);

- Form should have one <input> element with attribute 'type=email'
- Form should have one label element with attribute 'for=email_input_id' (used to display error/success message)
- All options are optional.

Options:
=======
options = {
    language: 'en',
    callback: callbackFunction,
    url: 'http://blahblah.us1.list-manage.com/subscribe/post?u=5afsdhfuhdsiufdba6f8802&id=4djhfdsh99f'
}

Notes:
=====
To get the mailchimp JSONP url (undocumented), change 'post?' to 'post-json?' and add '&c=?' to the end.
For e.g. 'http://blahblah.us1.list-manage.com/subscribe/post-json?u=5afsdhfuhdsiufdba6f8802&id=4djhfdsh99f&c=?',
*/

(function ($) {
  'use strict';

  $.ajaxChimp = {
    responses: {
      'We have sent you a confirmation email'                                             : 0,
      'Please enter a value'                                                              : 1,
      'An email address must contain a single @'                                          : 2,
      'The domain portion of the email address is invalid (the portion after the @: )'    : 3,
      'The username portion of the email address is invalid (the portion before the @: )' : 4,
      'This email address looks fake or invalid. Please enter a real email address'       : 5
    },
    translations: {
      'en': null
    },
    init: function (selector, options) {
      $(selector).ajaxChimp(options);
    }
  };

  $.fn.ajaxChimp = function (options) {
    $(this).each(function(i, elem) {
      var form = $(elem);
      var email = $('input[type="email"]',form);
      var label = form.find('label[for=' + email.attr('id') + ']');

      var settings = $.extend({
        'url': form.attr('action'),
        'language': 'en'
      }, options);

      var url = settings.url.replace('/post?', '/post-json?').concat('&c=?');
      form.attr('novalidate', 'true');
      email.attr('name', 'EMAIL');

      form.submit(function (e) {
        e.preventDefault()
        var msg;
        $('.Newsletter-Form-Desktop [type="submit"]').attr('disabled','disabled');
        $('.news-error').html('');
        $('.error-msg').html('');
        function successCallback(resp) {
          console.log(resp)
          if (resp.result === 'success') {
            msg = 'We have sent you a confirmation email';
            label.removeClass('error').addClass('valid');
            email.removeClass('error').addClass('valid');
            var couponCode = $('.mc-COUPON').val();
            //                       	$.ajax({

            //                             url: '/apps/coupon-app/CouponCodeService.svc/UpdateCouponEmail?sid=1&authtoken=d102e35bac039ffa3e641ecdce0d5b62&IsUsed=true&code='+couponCode+'&email='+$('input[name="EMAIL"]',form).val()+'', 

            //                             dataType: 'json',
            //                             contentType: "application/json; charset=utf-8",
            //                             crossDomain: true,
            //                             type: 'GET',
            //                             success: function (result) {

            //                             },
            //                             error: function (e) {
            //                             }
            //                         });

          } else {
            email.removeClass('valid').addClass('error');
            label.removeClass('valid').addClass('error');
            var index = -1;
            try {
              var parts = resp.msg.split(' - ', 2);
              if (parts[1] === undefined) {
                msg = resp.msg;
              } else {
                var i = parseInt(parts[0], 10);
                if (i.toString() === parts[0]) {
                  index = parts[0];
                  msg = parts[1];
                } else {
                  index = -1;
                  msg = resp.msg;
                }
              }
            }
            catch (e) {
              index = -1;
              msg = resp.msg;
            }

            $('.news-error').html(msg);
            //$("#newsletterpopup").hide();
            //$("#newsletteralreadysubcribrer").show();
            //$(".htmlappend").html(msg);

            try{
              var msgLow = msg.toLower();

              if(msgLow.indexOf('already subscribed') < 0)
              {
                form.find('input[type="submit"]').removeClass('p-loader');
                var couponCode = $('.mc-COUPON').val();
                if(couponCode != '')
                {
                  //                             $.ajax({

                  //                                 url: '/apps/coupon-app/CouponCodeService.svc/UpdateCoupon?sid=1&authtoken=d102e35bac039ffa3e641ecdce0d5b62&IsUsed=false&code='+couponCode,
                  //                                 dataType: 'json',
                  //                                 contentType: "application/json; charset=utf-8",
                  //                                 crossDomain: true,
                  //                                 type: 'GET',
                  //                                 success: function (result) {

                  //                                 },
                  //                                 error: function (e) {
                  //                                     //alert('Error Occured While proceeding your request!');
                  //                                     //return false;
                  //                                 }
                  //                             });
                }
              }

            }catch(err){

            }
          }

          // Translate and display message
          if (
            settings.language !== 'en'
            && $.ajaxChimp.responses[msg] !== undefined
            && $.ajaxChimp.translations
            && $.ajaxChimp.translations[settings.language]
            && $.ajaxChimp.translations[settings.language][$.ajaxChimp.responses[msg]]
          ) {
            msg = $.ajaxChimp.translations[settings.language][$.ajaxChimp.responses[msg]];
          }
          label.html(msg);

          label.show(2000);
          if (settings.callback) {
            settings.callback(resp);
          }
        }

        form.find('input[type="submit"]').addClass('p-loader'); //custom
        $.when(
          //               	$.ajax({

          //                     url:'/apps/coupon-app/CouponCodeService.svc/GetUnUsedCoupon?sid=1&authtoken=d102e35bac039ffa3e641ecdce0d5b62&email='+$('input[name="EMAIL"]',form).val()+'', 
          //                     dataType: 'json',
          //                     contentType: "application/json; charset=utf-8",
          //                     crossDomain: true,
          //                     type: 'GET',
          //                     success: function (result) {
          //                        if(result.status == 'success'){
          //                        	$('.mc-COUPON').val(result.code);
          //                        }
          //                     },
          //                     error: function (e) {
          //                         alert('Error Occured While proceeding your request!');
          //                         return false;
          //                     }
          //                 })
        ).done(function(){
          var data = {};
          var dataArray = form.serializeArray();
          $.each(dataArray, function (index, item) {
            data[item.name] = item.value;
          });
          $.ajax({
            url: url,
            data: data,
            success: successCallback,
            dataType: 'jsonp',
            error: function (resp, text) {
              var couponCode = $('.mc-COUPON').val();
              if(couponCode != '')
              {
                //                       	$.ajax({

                //                             url: '/apps/coupon-app/CouponCodeService.svc/UpdateCoupon?sid=1&authtoken=d102e35bac039ffa3e641ecdce0d5b62&IsUsed=false&code='+couponCode,
                //                             dataType: 'json',
                //                             contentType: "application/json; charset=utf-8",
                //                             crossDomain: true,
                //                             type: 'GET',
                //                             success: function (result) {

                //                             },
                //                             error: function (e) {
                //                                 //alert('Error Occured While proceeding your request!');
                //                                 //return false;
                //                             }
                //                         });
              }
              form.find('input[type="submit"]').removeClass('p-loader');
              $('.Newsletter-Form-Desktop [type="submit"]').removeAttr('disabled')
              msg = 'Error Occured While Proceeding Your Request!';

            }
          });

          // Translate and display submit message
          var submitMsg = 'Submitting...';
          if(
            settings.language !== 'en'
            && $.ajaxChimp.translations
            && $.ajaxChimp.translations[settings.language]
            && $.ajaxChimp.translations[settings.language]['submit']
          ) {
            submitMsg = $.ajaxChimp.translations[settings.language]['submit'];
          }
          label.html(submitMsg).show(2000);
        });
        return false;
      });
    });
    return this;
  };
})(jQuery);